import { IClientsContract } from 'src/utils/Interfaces/client.interface'
import style from './style.module.scss'

export const ContractItem = ({ item }: { item: IClientsContract }) => {
  return (
    <li className={style.contract_item}>
      <span>{item.name}</span>
      <span>{item.status}</span>
      <span>{item.startDate}</span>
      <span>{item.endDate}</span>
      <span>
        {item.goals.map((goal) => {
          return (
            <div>
              <span>{goal.key}</span> {goal.value}
            </div>
          )
        })}
      </span>
      <span>{item.currentGoals}</span>

      <span>
        <img src="/src/assets/img/icons/dots.svg" alt="dots" />
      </span>
    </li>
  )
}
